const detectInteraction = () => {
  window.removeEventListener('touchmove', detectInteraction)
  window.removeEventListener('mousemove', detectInteraction)

  document.documentElement.classList.remove('no-interaction')
  document.documentElement.classList.add('interaction')
}

window.addEventListener('touchstart', detectInteraction)
window.addEventListener('mousemove', detectInteraction)
